import { BaseModel, type RelationConfig } from './base';
import { Service } from './service';
import { Tax } from './tax';

export enum PassExpiryMode {
  booking = 1,
  appointment = 2,
}

export const PassExpiryModeLabels: Record<PassExpiryMode, string> = {
  [PassExpiryMode.booking]: 'pass.expiryModeBooking',
  [PassExpiryMode.appointment]: 'pass.expiryModeAppointment',
};

export enum PassCancelReservationBehaviour {
  return = 0,
  leave = 1,
}

export const PassCancelReservationBehaviourLabels: Record<PassCancelReservationBehaviour, string> = {
  [PassCancelReservationBehaviour.return]: 'pass.returnPassUsage',
  [PassCancelReservationBehaviour.leave]: 'pass.leavePassUsage',
};

export enum PassDeleteReservationBehaviour {
  return = 0,
  leave = 1,
}

export const PassDeleteReservationBehaviourLabels: Record<PassDeleteReservationBehaviour, string> = {
  [PassDeleteReservationBehaviour.return]: 'pass.returnPassUsage',
  [PassDeleteReservationBehaviour.leave]: 'pass.leavePassUsage',
};

export class PassService extends BaseModel {
  idPassService!: number;

  override objectID(): string | null {
    return this.idPassService?.toString() ?? null;
  }
}

export class PassOptions extends BaseModel {
  services!: Service[];
  taxes!: Tax[];

  static override relations(): RelationConfig {
    return {
      services: { type: Service },
      taxes: { type: Tax },
    };
  }
}

export class Pass extends BaseModel {
  static modelName(): string {
    return 'pass'
  }

  idPass!: number;
  name!: string;
  price!: number;
  information!: string;
  instructions!: string;
  allowInternet!: boolean;
  allowGifting!: boolean;
  onlineLimitPerCustomer!: number;
  loyaltyEnabled!: boolean;
  expiredNotificationEnabled!: boolean;
  preselectAtConfirmationDefault!: boolean;
  numberOfUses!: number;
  expiryDays!: number;
  expiryMode!: PassExpiryMode;
  cancelReservationBehaviour!: PassCancelReservationBehaviour;
  deleteReservationBehaviour!: PassDeleteReservationBehaviour;
  hasImage!: boolean;
  images!: { square?: string } | null;
  imageUrls!: { square?: string } | null;
  options!: PassOptions;
  services!: PassService[];

  static override relations(): RelationConfig {
    return {
      options: { type: PassOptions },
      services: { type: PassService },
    };
  }

  override objectID(): string | null {
    return this.idPass?.toString() ?? null;
  }

  get expires(): boolean {
    return this.expiryDays !== 0;
  }

  set expires(value: boolean) {
    this.expiryDays = value ? 1 : 0;
  }

  get isLimitedUse(): boolean {
    return this.numberOfUses !== 0;
  }

  set isLimitedUse(value: boolean) {
    this.numberOfUses = value ? 1 : 0;
  }

  get image(): string | null {
    if (this.hasImage) {
      return this.images?.square || this.imageUrls?.square || null;
    }
    return null;
  }

  get initials(): string {
    return this.name?.charAt(0).toUpperCase() ?? '';
  }
}
